module.exports = __webpack_public_path__ + "img/innovation-1.189511e0.jpg";